import * as Dialog from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import { LoaderIcon, X } from 'lucide-react';
import SaveImageModal from './SaveImageModal';

interface ApplyChangesDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isPending: boolean;
  handleContinueWithoutSaving: () => void;
  formState: any;
}

const ApplyChangesDialog: React.FC<ApplyChangesDialogProps> = ({
  isOpen,
  setIsOpen,
  isPending,
  handleContinueWithoutSaving,
  formState,
}) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50" />
        <Dialog.Content className="fixed text-text-primary bg-background left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-lg p-6 shadow-lg w-[400px] max-w-[calc(100%-32px)]">
          <div className="flex flex-col gap-4">
            <div className="flex justify-between items-start">
              <Dialog.Title className="text-2xl font-bold">
                Apply Changes
              </Dialog.Title>
              <Dialog.Close asChild>
                <button className="rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2">
                  <X className="h-4 w-4" />
                  <span className="sr-only">Close</span>
                </button>
              </Dialog.Close>
            </div>
            <p>
              Are you sure you want to apply the changes? Please save the
              current version to ensure that you don&apos;t lose this image
            </p>
            <div className="flex justify-end gap-2 mt-2">
              <Button
                type="button"
                onClick={handleContinueWithoutSaving}
                variant={'customSecondary'}
                size={'sm'}
              >
                Continue without saving
              </Button>
              <SaveImageModal />
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ApplyChangesDialog;
